
<template>
  <!-- 使用说明：表格宽高为父容器的100%，标签名称 el-pagetable，需要传入的属性部分说明： -->
  <!-- 需传入url，若不使用封装的axios中baseUrl则use-base-url传入false -->
  <!-- axios默认调取接口方法为get， -->
  <!-- 查询参数传入params中，传入后参数对象会默认加入分页参数pageSize，pageIndex，后台按以上名字接收 -->
  <!-- 后台返回的数据格式为{code:200,msg:'success',data:[...],coount:100} -->
  <!-- 若显示序号行直接传入 index-column:true 即可，会自动在最前面的列加入序号行 -->
  <!-- 若开启多选功能需要传入checked-column:true即可，会自动在最前面加入多选列 -->
  <!-- 若开启自定义排序功能需要传入custom-sort:true即可，会自动在参数中加入sort属性，排序改变时sort值格式：字段名称 +' '+asc/desc,如：id asc -->
  <!-- 传入列数据使用<template slot="columns"> 在这里写入列数据</template> -->
  <div class="component" ref="container">
    <el-table
      :data="tableData"
      :height="tableHeight"
      ref="mytable"
      class="mytable"
      :stripe="stripe"
      :border="border"
      :highlight-current-row="highlightCurrentRow"
      :size="size"
      :fit="fit"
      :showHeader="showHeader"
      :emptyText="emptyText"
      :default-expand-all="defaultExpandAll"
      :default-sort="defaultSort"
      :empty-text="emptyText"
      :select-on-indeterminate="selectOnIndeterminate"
      :indent="indent"
      v-loading="loading"
    >
      <el-table-column
        type="selection"
        width="55"
        align="center"
        v-if="checkedColumn"
      ></el-table-column>
      <el-table-column
        label="序号"
        align="center"
        width="70"
        v-if="indexColumn && !fixedNumCol"
      >
        <template scope="scope">
          <span>{{ scope.$index + (pageIndex - 1) * pageSize + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="序号"
        align="center"
        width="70"
        fixed="left"
        v-if="indexColumn && fixedNumCol"
      >
        <template scope="scope">
          <span>{{ scope.$index + (pageIndex - 1) * pageSize + 1 }}</span>
        </template>
      </el-table-column>
      <slot name="columns"></slot>
    </el-table>
    <el-pagination
      ref="mypage"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="pageSize"
      :current-page="pageIndex"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>
<script>
import "../assets/global/table.css";
export default {
  props: {
    //查询数据的url
    url: String,
    //是否使用baseUrl
    useBaseUrl: {
      type: Boolean,
      default: true,
    },
    //查询数据的方法
    method: {
      type: String,
      default: "GET",
    },
    //查询参数
    params: Object,
    //是否开启自定义排序
    customSort: {
      type: Boolean,
      default: false,
    },
    //是否显示序号列
    indexColumn: {
      type: Boolean,
      default: false,
    },
    //是否开启多选框列
    checkedColumn: {
      type: Boolean,
      default: false,
    },
    //是否首次自动加载数据
    autoLoad: {
      type: Boolean,
      default: true,
    },
    //以下为eltable中的属性，这里接收后重新赋给eltable
    stripe: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: false,
    },
    rowClassName: {
      type: Function,
      default: function () {},
    },
    highlightCurrentRow: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "medium ",
    },
    fit: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    emptyText: {
      type: String,
      default: "暂无数据",
    },
    defaultExpandAll: {
      type: Boolean,
      default: false,
    },
    defaultSort: {
      type: Object,
    },
    tooltipEffect: {
      type: String,
      default: "dark",
    },
    selectOnIndeterminate: {
      type: Boolean,
      default: true,
    },
    indent: {
      type: Number,
      default: 16,
    },
    fixedNumCol: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showCheckColumn: false,
      tableData: [],
      myParams: this.params,
      total: 0,
      pageSize: 25,
      pageIndex: 1,
      loading: false,
      tableHeight: null,
    };
  },
  methods: {
    headerStyle({ row, rowIndex }) {
      return "tableHead";
    },
    //根据父组件是否传入事件方法判断是否监听eltable中对应的事件
    bindEvent() {
      let that = this;

      if (that.$listeners["select"]) {
        that.$refs.mytable.$on("select", function (selection, row) {
          that.$emit("select", selection, row);
        });
      }

      if (that.$listeners["select-all"]) {
        that.$refs.mytable.$on("select-all", function (selection) {
          that.$emit("select-all", selection);
        });
      }

      if (that.$listeners["selection-change"]) {
        that.$refs.mytable.$on("selection-change", function (selection) {
          that.$emit("selection-change", selection);
        });
      }

      if (that.$listeners["cell-mouse-enter"]) {
        that.$refs.mytable.$on("cell-mouse-enter", function (
          row,
          column,
          cell,
          event
        ) {
          that.$emit("cell-mouse-enter", row, column, cell, event);
        });
      }
      if (that.$listeners["cell-mouse-leave"]) {
        that.$refs.mytable.$on("cell-mouse-leave", function (
          row,
          column,
          cell,
          event
        ) {
          that.$emit("cell-mouse-leave", row, column, cell, event);
        });
      }
      if (that.$listeners["cell-click"]) {
        that.$refs.mytable.$on("cell-click", function (
          row,
          column,
          cell,
          event
        ) {
          that.$emit("cell-click", row, column, cell, event);
        });
      }
      if (that.$listeners["cell-dblclick"]) {
        that.$refs.mytable.$on("cell-dblclick", function (
          row,
          column,
          cell,
          event
        ) {
          that.$emit("cell-dblclick", row, column, cell, event);
        });
      }
      if (that.$listeners["row-click"]) {
        that.$refs.mytable.$on("row-click", function (row, column, event) {
          that.$emit("row-click", row, column, event);
        });
      }
      if (that.$listeners["row-contextmenu"]) {
        that.$refs.mytable.$on("row-contextmenu", function (
          row,
          column,
          event
        ) {
          that.$emit("row-contextmenu", row, column, event);
        });
      }
      if (that.$listeners["row-dblclick"]) {
        that.$refs.mytable.$on("row-dblclick", function (row, column, event) {
          that.$emit("row-dblclick", row, column, event);
        });
      }
      if (that.$listeners["header-click"]) {
        that.$refs.mytable.$on("header-click", function (column, event) {
          that.$emit("header-click", column, event);
        });
      }
      if (that.$listeners["header-contextmenu"]) {
        that.$refs.mytable.$on("header-contextmenu", function (column, event) {
          that.$emit("header-contextmenu", column, event);
        });
      }
      if (this.customSort) {
        that.$refs.mytable.$on("sort-change", function (obj) {
          that.sortChange(obj);
        });
      }
      if (that.$listeners["filter-change"]) {
        that.$refs.mytable.$on("filter-change", function (obj) {
          that.$emit("filter-change", obj);
        });
      }
      if (that.$listeners["current-change"]) {
        that.$refs.mytable.$on("current-change", function (
          currentRow,
          oldCurrentRow
        ) {
          that.$emit("current-change", currentRow, oldCurrentRow);
        });
      }
      if (that.$listeners["header-dragend"]) {
        that.$refs.mytable.$on("header-dragend", function (
          newWidth,
          oldWidth,
          column,
          event
        ) {
          that.$emit("header-dragend", newWidth, oldWidth, column, event);
        });
      }
      if (that.$listeners["expand-change"]) {
        that.$refs.mytable.$on("expand-change", function (row, obj) {
          that.$emit("expand-change", row, obj);
        });
      }
    },
    loadData() {
      let that = this;
      if (!that.myParams) {
        that.myParams = {};
      }
      that.myParams.pageSize = that.pageSize;
      that.myParams.pageIndex = that.pageIndex;
      that.loading = true;
      that.$api.axios(
        that.method,
        that.url,
        that.myParams,
        function (res) {
          if (res.code == 200) {
            that.total = res.count;
            that.tableData = res.data;
          }
          that.$emit("loaded", res);
          that.loading = false;
        },
        function () {
          that.$message.error("获取数据失败");
          that.loading = false;
        },
        that.useBaseUrl
      );
    },
    reload() {
      this.pageIndex = 1;
      this.loadData();
    },
    //每页条数变化事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadData();
    },
    //当前页变化事件
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.loadData();
    },
    sortChange(val) {
      let that = this;
      if (!that.myParams) {
        that.myParams = {};
      }
      let sort = "";
      if (val.prop && val.order) {
        sort = val.prop + " " + (val.order == "ascending" ? "asc" : "desc");
      }
      that.myParams.sort = sort;
      that.loadData();
    },
  },
  created() {},
  mounted() {
    let that = this;
    this.$nextTick(function () {
      that.bindEvent();
      if (that.autoLoad) {
        that.loadData();
      }
      that.tableHeight = that.$refs.container.clientHeight - 67;
      window.onresize = function () {
        that.tableHeight = that.$refs.container.clientHeight - 67;
      };
    });
  },
  watch: {
    params() {
      this.myParams = this.params;
    },
  },
};
</script>
<style lang="less" scoped>
.component {
  height: 100%;
  width: 100%;
}
.el-pagination {
  margin-top: 15px;
}
</style>